import { render, staticRenderFns } from "./admin-quota-requests.vue?vue&type=template&id=32063590&lang=pug&"
import script from "./admin-quota-requests.vue?vue&type=script&lang=js&"
export * from "./admin-quota-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports